<template>
    <div>
        <h1 class="display-heading">Bulk Upload Drug Items</h1>

        <div class="mb-3">
            <h5>Sample Format</h5>
            <img src="/static/samples/sample_drug_list.png" class="img-fluid mb-3">
            <a href="/static/samples/sample_drug_list.xlsx" target="_blank" class="btn btn-primary btn-primary-insv">Download Sample File</a>
        </div>

        <div class="mb-5">
            <div class="card">
                <div class="card-header">Upload Drug Items</div>
                <div class="card-body">
                    <form @submit.prevent="validateForm">
                        <div>
                            <div class="form-group row">
                                <label class="col-sm-3 col-xl-2 col-form-label">Drug List File</label>
                                <div class="col-sm-9 col-xl-10">
                                    <input id="uploadFileInput" type="file" v-validate="'required|mimes:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'" data-vv-as="drug list file" name="drugList"
                                        :class="{'is-invalid':  validationErrors.has('drugList')}">
                                    <div v-show="validationErrors.has('drugList')" class="invalid-feedback">
                                        {{ validationErrors.first('drugList') }}
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-9 offset-sm-3 col-xl-10 offset-xl-2">
                                    <p v-show="isSubmitMessageShown" :class="{
                                        'text-danger': isSubmitMessageError,
                                        'mb-3': true
                                    }">
                                        {{submitMessage}}
                                    </p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-9 offset-sm-3 col-xl-10 offset-xl-2">
                                    <button type="button" class="btn btn-primary btn-primary-insv" @click="validateForm">Upload Drug List</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    Validator
} from 'vee-validate';
export default {
    'name': 'BulkUploadDrugs',
    data () {
        return {
            'isSubmitMessageShown': false,
            'isSubmitMessageError': false,
            'submitMessage': ''
        };
    },
    mounted () {
        const dict = {
            'custom': {
                'drugList': {
                    'required': 'You must select a file to upload.',
                    'mimes': 'The selected file must be an excel file.'
                }
            }
        };
        Validator.localize('en', dict);
        this.$validator.localize('en', dict);
    },
    'methods': {
        validateForm () {
            this.isSubmitMessageShown = true;
            this.isSubmitMessageError = false;
            this.$validator.validateAll().then((isValidate) => {
                if (isValidate) {
                    let drugsFile = document.querySelector('#uploadFileInput');
                    let formData = new FormData();
                    formData.append('DrugUploadFile', drugsFile.files[0]);
                    this.submitMessage = 'Uploading and saving drug list...';

                    this.axios.post('Drugs/BulkUpload', formData, {
                        'headers': {
                            'Content-Type': 'multipart/form-data'
                        } }).then(() => {
                        this.submitMessage = 'Successfully processed drug list!';

                        this.$router.push({ 'name': 'list-drugs' });
                    }).catch((error) => {
                        this.isSubmitMessageError = true;
                        if (error.response.data) {
                            this.submitMessage = error.response.data.message;
                        } else {
                            this.submitMessage = 'Error saving drug list. Please try again.';
                        }
                    });
                } else {
                    this.isSubmitMessageError = true;
                    this.submitMessage = 'You have error in the form. Please check your input(s) before saving drug list.';
                }
            });
        }
    }
};

</script>

<style>

</style>
